(() => {
  angular.module('app.settings').config(($routeProvider, $locationProvider) => {
    $locationProvider.html5Mode(true);

    $routeProvider.when('/basicinfo', {
      templateUrl: `../../assets/js/app/settings/partials/basicinfo.html?v=${window.BUILD_VERSION}`,
      controller: 'BasicInfoSettingsController',
      controllerAs: 'basicInfoSettings',
      resolve:{
        'AccountData' : (SettingsService) => SettingsService.accountServicePromise
      }
    }).when('/apiintegrations', {
      templateUrl: `../../assets/js/app/settings/partials/integrations.html?v=${window.BUILD_VERSION}`,
      controller: 'IntegrationsSettingsController',
      controllerAs: 'integrationsSettings',
      resolve: {
        'IntegrationsData': (SettingsService) => SettingsService.integrationsServicePromise
      }
    }).when('/apiintegrations/dfp', {
      templateUrl: `../../assets/js/app/settings/partials/integrations.dfp.html?v=${window.BUILD_VERSION}`,
      controller: 'IntegrationsDFPController',
      controllerAs: 'integrationsDFP'
    }).when('/integratedcampaigns', {
      templateUrl: `../../assets/js/app/settings/partials/integratedcampaigns.html?v=${window.BUILD_VERSION}`,
      controller: 'IntegratedCampaignsSettingsController',
      controllerAs: 'integratedCampaignsSettings'
    }).when('/customsegments', {
      templateUrl: `../../assets/js/app/settings/partials/customsegments.html?v=${window.BUILD_VERSION}`,
      controller: 'CustomSegmentsSettingsController',
      controllerAs: 'customSegmentsSettings',
      resolve: {
        'CustomSegmentsData': (SettingsService) => SettingsService.customSegmentsPromise
      }
    }).when('/log/adform', {
      templateUrl: `../../assets/js/app/settings/adform/adform.log.html?v=${window.BUILD_VERSION}`,
      controller: 'AdformLogController',
      controllerAs: 'adformLog',
      resolve: {}
    })
  });
})();
